const USER_EMAILS_ASSIGNABLE_TO_DIRECTOR_ROLE = new Set<string>(['jan@hanselmann.de', 'f.hanselmann@hanselmann.de'])

// Ensure only specific users can be assigned the "director" role
// https://github.com/sidestream-tech/hanselmann-os/issues/5050
export default (userEmail: string | undefined): boolean => {
  return !!userEmail && USER_EMAILS_ASSIGNABLE_TO_DIRECTOR_ROLE.has(userEmail)
}
